import axios from './request'
// console.log(typeof axios);// 'function'
// 服务器地址
// export const host = 'http://120.26.30.18:3001'
// 本地测试
// export const host = 'http://127.0.0.1:3000'
export const host = process.env.VUE_APP_HOST
console.log(12111,host);
// 处理图片的接口
export const uploadPhoto = (data = {}) => {
    return axios.post(`${host}/api/photo/upload`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const removePhoto = (data = {}) => {
    return axios.post(`${host}/api/photo/delete`, data)
}

// 处理轮播图的接口
export const publishBanner = (data = {}) => {
    return axios.get(`${host}/api/banner/add`, { params: data })
}
export const listBanner = () => {
    return axios.get(`${host}/api/banner/list`)
}

export const searchBanner = (data = {}) => {
    return axios.get(`${host}/api/banner/search`, { params: data })
}
export const removeBanner = (data = {}) => {
    return axios.get(`${host}/api/banner/remove`, { params: data })
}
export const modifyBanner = (data = {}) => {
    return axios.get(`${host}/api/banner/modify`, { params: data })
}

// 处理导航的接口
export const addCate = (data = {}) => {
    return axios.get(`${host}/api/cate/add`, { params: data })
}
export const listCate = () => {
    return axios.get(`${host}/api/cate/list`)
}
export const searchCate = (data = {}) => {
    return axios.get(`${host}/api/cate/search`, { params: data })
}
export const removeCate = (data = {}) => {
    return axios.get(`${host}/api/cate/remove`, { params: data })
}
export const modifyCate = (data = {}) => {
    return axios.get(`${host}/api/cate/modify`, { params: data })
}
export const itemsCate = (data = {}) => {
    return axios.get(`${host}/api/cate/items`, { params: data })
}


// 用户相关的接口（管理员）
// 判断用户是否登录
export const isLogined = (data = {}) => {
    return axios.post(`${host}/api/user/isLogined`, data)
}
export const adminLogin = (data = {}) => {
    return axios.post(`${host}/api/admin/login`, data)
}

// 

// 文章接口处理
export const publishArticle = (data = {}) => {
    return axios.post(`${host}/api/article/publish`, data, { headers: { token: localStorage.getItem("AUTO_TOKEN") } })
}

export const itemsArticle = (data = {}) => {
    return axios.post(`${host}/api/article/items`, data)
}
export const listArticle = () => {
    return axios.post(`${host}/api/article/list`)
}


export const deleteArticle = (data = {}) => {
    return axios.post(`${host}/api/article/delete`, data, { headers: { token: localStorage.getItem("AUTO_TOKEN") } })
}
// 搜索文章
// 请求方式：POST
// 请求地址：http://localhost:3001/api/article/search 
// 参数：keyword
export const searchArticle = (data = {}) => {
    return axios.post(`${host}/api/article/search`, data)
}

// 用户接口
export const itemsUser = (data = {}) => {
    return axios.post(`${host}/api/user/items`, data)
}
export const deleteUser = (data = {}) => {
    return axios.post(`${host}/api/user/delete`, data)
}


// 查看用户列表
// 请求地址：http://localhost:3001/api/user/list
// 请求方式：POST
// 参数：无
export const listUser = () => {
    return axios.post(`${host}/api/user/list`)
}

// 搜索用户
// 请求地址：http://localhost:3001/api/user/search 
// 请求方式：POST
// 参数：keyword
export const searchUser = (data = {}) => {
    return axios.post(`${host}/api/user/search`, data)
}

// 发布随笔接口
// 请求方式 POST
// 请求地址：http://localhost:3001/api/note/publish
// 参数： note_text
export const publishNote = (data = {}) => {
    return axios.post(`${host}/api/note/publish`, data)
}

// 修改随笔接口
// 请求方式 POST
// 请求地址：http://localhost:3001/api/note/modify
// 参数： note_text ，id
export const modifyNote = (data = {}) => {
    return axios.post(`${host}/api/note/modify`, data)
}

// 删除随笔接口
// 请求方式 POST
// 请求地址：http://localhost:3001/api/note/remove
// 参数： id
export const removeNote = (data = {}) => {
    return axios.post(`${host}/api/note/remove`, data)
}

// 获取随笔分页列表
// 请求方式 POST
// 请求地址：http://localhost:3001/api/note/list
// 参数：page_num page_size
export const listNote = (data = {}) => {
    return axios.post(`${host}/api/note/list`, data)
}

// 搜索随笔接口
// 请求方式 POST
// 请求地址：http://localhost:3001/api/note/search
// 参数：keyword
export const searchNote = (data = {}) => {
    return axios.post(`${host}/api/note/search`, data)
}


// 搜索相册记录
// 请求方式：post
// 参数：keyword
// 请求地址：http://localhost:3001/api/picture/search
export const searchPicture = (data = {}) => {
    return axios.post(`${host}/api/picture/search`, data)
}

// 添加相册记录
// 请求方式：post
// 参数：photo_title,  photo_url
// 请求地址：http://localhost:3001/api/picture/publish
export const publishPicture = (data = {}) => {
    return axios.post(`${host}/api/picture/publish`, data)
}

// 修改相册记录
// 请求方式：post
// 参数：photo_title, photo_url ,id
// 请求地址：http://localhost:3001/api/picture/modify
export const modifyPicture = (data = {}) => {
    return axios.post(`${host}/api/picture/modify`, data)
}

// 删除相册记录
// 请求方式：post
// 参数：id
// 请求地址：http://localhost:3001/api/picture/remove
export const removePicture = (data = {}) => {
    return axios.post(`${host}/api/picture/remove`, data)
}

// 获取相册分页列表
// 请求方式：post
// 参数：page_num, page_size
// 请求地址：http://localhost:3001/api/picture/items
export const itemsPicture = (data = {}) => {
    return axios.post(`${host}/api/picture/items`, data)
}

// 修改文章评论
// 方式：POST
// 示例： http://localhost:3001/api/articleComment/modify
// 参数： comment,id
// 响应数据格式: json格式
export const modifyArticleComment = (data = {}) => {
    return axios.post(`${host}/api/articleComment/modify`, data)
}

// 删除文章评论
// 方式：POST
// 参数： id
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/articleComment/remove
export const removeArticleComment = (data = {}) => {
    return axios.post(`${host}/api/articleComment/remove`, data)
}

// 搜索文章评论列表
// 方式：POST
// 参数： keyword
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/articleComment/search
export const searchArticleComment = (data = {}) => {
    return axios.post(`${host}/api/articleComment/search`, data)
}

// 获取分页文章评论列表
// 方式：POST
// 参数： page_num, page_size
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/articleComment/items
export const itemsArticleComment = (data = {}) => {
    return axios.post(`${host}/api/articleComment/items`, data)
}

// 获取随笔评论分页列表
// 方式：POST
// 参数： page_num, page_size
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/noteComment/items
export const itemsNoteComment = (data = {}) => {
    return axios.post(`${host}/api/noteComment/items`, data)
}

// 修改随笔评论
// 方式：POST
// 参数： comment,id
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/noteComment/modify
export const modifyNoteComment = (data = {}) => {
    return axios.post(`${host}/api/noteComment/modify`, data)
}

// 删除随笔评论
// 方式：POST
// 参数： id
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/noteComment/remove
export const removeNoteComment = (data = {}) => {
    return axios.post(`${host}/api/noteComment/remove`, data)
}

// 搜索随笔评论列表
// 方式：POST
// 参数： keyword
// 响应数据格式: json格式
// 示例： http://localhost:3001/api/noteComment/search
export const searchNoteComment = (data = {}) => {
    return axios.post(`${host}/api/noteComment/search`, data)
}



// 修改祝福
// 请求方式 post
// 请求地址：http://localhost:3001/api/wish/modify?wish_text=测试&id=1
// 参数： wish_text id
export const modifyWish = (data = {}) => {
    return axios.post(`${host}/api/wish/modify`, data)
}

// 删除祝福
// 请求方式 post
// 请求地址：http://localhost:3001/api/wish/remove?&id=1
// 参数：  id
export const removeWish = (data = {}) => {
    return axios.post(`${host}/api/wish/remove`, data)
}

// 获取祝福分页列表
// 请求方式 post
// 请求地址：http://localhost:3001/api/wish/list
// 参数：page_num page_size
export const listWish = (data = {}) => {
    return axios.post(`${host}/api/wish/list`, data)
}

// 搜索祝福
// 请求方式 post
// 请求地址：http://localhost:3001/api/wish/search?keyword=测试
// 参数：keyword
export const searchWish = (data = {}) => {
    return axios.post(`${host}/api/wish/search`, data)
}



// 修改留言
// 请求方式：POST
// 请求地址：http://localhost:3001/api/msg/modify
// 参数： msg_text ，id
export const modifyMsg = (data = {}) => {
    return axios.post(`${host}/api/msg/modify`, data)
}

// 删除留言
// 请求方式：POST
// 请求地址：http://localhost:3001/api/msg/remove
// 参数： id
export const removeMsg = (data = {}) => {
    return axios.post(`${host}/api/msg/remove`, data)
}

// 获取留言分页列表
// 请求方式：POST
// 请求地址：http://localhost:3001/api/msg/items
// 参数：page_num, page_size
export const itemsMsg = (data = {}) => {
    return axios.post(`${host}/api/msg/items`, data)
}
// 搜索留言
// 请求方式：POST
// 搜索地址：http://localhost:3001/api/msg/search
// 参数：keyword
export const searchMsg = (data = {}) => {
    return axios.post(`${host}/api/msg/search`, data)
}
// 管理员修改自己密码
// 请求方式：POST
// 请求地址：http://localhost:3001/api/admin/changePassword
// 参数：oldPassword, newPassword ,token
export const changePassword = (data = {}) => {
    return axios.post(`${host}/api/admin/changePassword`, data)
}

// 获取账号数据
// 请求地址：http://localhost:3001/api/user/detail2 
// 请求方式：POST
// 参数：token
export const detail2 = (data = {}) => {
    return axios.post(`${host}/api/user/detail2`, data)
}